export const getSuffix = (name) => {
    switch (name) {
        case 'bijtelling_pct':
            return  "%";
        case 'aantal_deuren':
            return ' deuren';
        case 'tellerstand':
            return ' km';
        default:
            return '';
    }
};
